var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 56.3",
    enableBackground: "new 0 0 56.3 56.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_873_",
    opacity: 0.98,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 28.1,
    cy: 28.1,
    r: 27.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    fill: "#FFFFFF",
    d: "M37.4,28.2H19.6c-2.8,0-5.1,2.3-5.1,5.1v4.1c0,2.8,2.3,5.1,5.1,5.1h17.7    c2.8,0,5.1-2.3,5.1-5.1v-4.1C42.5,30.5,40.2,28.2,37.4,28.2z M23.3,31.4h-1.6v8.2h-1.6v-8.2h-1.6V30h4.9V31.4z M28,39.6h-1.4v-0.8    c-0.3,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.6,0.2-0.8,0.2c-0.3,0-0.6-0.1-0.7-0.3C24,39.2,24,38.9,24,38.5v-5.9h1.4V38    c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.4-0.1c0.2-0.1,0.3-0.2,0.4-0.4v-5.4H28V39.6z M33.1,38.2    c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.3-0.5,0.4-1,0.4c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.3-0.6-0.5v0.5h-1.4V30h1.4v3.1    c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.4-0.2,0.7-0.2c0.4,0,0.8,0.1,1,0.5c0.2,0.3,0.4,0.7,0.4,1.3V38.2z M38,36.3h-2.7v1.3    c0,0.4,0,0.6,0.1,0.8c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.1-0.4,0.1-0.8v-0.3H38v0.4c0,0.7-0.2,1.3-0.5,1.6    c-0.4,0.4-0.9,0.5-1.6,0.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.5-0.9-0.5-1.6v-3.2c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,0.9-0.6,1.5-0.6    c0.6,0,1.1,0.2,1.5,0.5c0.3,0.4,0.5,0.9,0.5,1.5V36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_857_",
    fill: "#FFFFFF",
    d: "M36,33.6c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.1,0.3-0.1,0.6v0.7h1.3v-0.7    c0-0.3-0.1-0.5-0.1-0.6C36.3,33.7,36.2,33.6,36,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_856_",
    fill: "#FFFFFF",
    d: "M31.1,33.6c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.2v4.4c0.1,0.1,0.2,0.2,0.3,0.3    c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0.1-0.5v-3.7c0-0.2,0-0.4-0.1-0.5C31.4,33.6,31.3,33.6,31.1,33.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_855_",
    fill: "#FFFFFF",
    points: "21.9,25.8 23.7,25.8 23.7,21.4 25.8,15.2 24,15.2 22.9,19.4 22.8,19.4 21.6,15.2     19.8,15.2 21.9,21.6   "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_852_",
    fill: "#FFFFFF",
    d: "M28.2,26c0.7,0,1.3-0.2,1.7-0.6c0.4-0.4,0.6-0.9,0.6-1.6v-4c0-0.6-0.2-1.1-0.6-1.5    c-0.4-0.4-1-0.6-1.6-0.6c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.4v4c0,0.7,0.2,1.2,0.6,1.6C27,25.8,27.5,26,28.2,26z     M27.6,19.7c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.4v4.2    c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_851_",
    fill: "#FFFFFF",
    d: "M33,25.9c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.6-0.4,0.9-0.7v0.9h1.6V18h-1.6v5.9    c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.4v-6h-1.6v6.5    c0,0.5,0.1,0.8,0.3,1C32.3,25.8,32.6,25.9,33,25.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0b421e14c3f8beaa2bf9810d483abd61.svg";
export { ForwardRef as ReactComponent };